import { Colors } from '@/constants/theme';
import { useTheme } from '@/contexts/ThemeContext';

export function useThemeColor(
  props: { light?: string; dark?: string },
  colorName: keyof typeof Colors.light
) {
  const { effectiveTheme } = useTheme();
  const themeColors = effectiveTheme === 'dark' ? Colors.dark : Colors.light;
  
  // Si hay color específico para el tema actual, usarlo
  if (effectiveTheme === 'dark' && props.dark) {
    return props.dark;
  }
  if (effectiveTheme === 'light' && props.light) {
    return props.light;
  }
  
  // Si hay color específico para el otro tema, usar el del tema actual
  if (props.light && !props.dark) {
    return props.light;
  }
  if (props.dark && !props.light) {
    return props.dark;
  }
  
  // Usar color del tema actual desde Colors
  return themeColors[colorName];
}
